import {PageHeader} from "@ant-design/pro-layout";
import {Input} from "antd";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import ScheduleModal from "./components/schedule-modal/ScheduleModal";
import useScheduleController from "../../controllers/schedule-controller";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import {useAuth} from "../../context/authContext";
import ScheduleList from "./components/schedule-list/ScheduleList";
import {useDevice} from "../../context/deviceContext";
import ScheduleTable from "./components/schedule-table/ScheduleTable";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import React from "react";
import {SearchOutlined} from "@ant-design/icons";
import "./style.less"

const AdmissionSchedulePage = () => {
  const {canManageContent} = useAuth()
  const scheduleController = useScheduleController()
  const {isCreateModalOpen, setSearchValue} = scheduleController
  const {isMobile} = useDevice()

  const createButtonHandler = () => {
    scheduleController.toggleCreateModalVisible()
  }

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={createButtonHandler}/>}
    <Input className="admission-schedule-page__search" prefix={<SearchOutlined/>} allowClear onChange={(e) => {
      setSearchValue(e.target.value)
    }} placeholder="Пошук лікаря"/>
  </>


  return <div className="admission-schedule-page">
    <div className="page_title admission-schedule-page__header">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Графік прийому</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>
    <div className='page_content admission-schedule-page__content'>
      <header className="admission-schedule-page__intro">
        <div className="admission-schedule-page__eyebrow">Плануйте свій візит</div>
        <h1 className="admission-schedule-page__title">Графік прийому лікарів</h1>
        <p className="admission-schedule-page__description">Оберіть потрібного фахівця та перевірте актуальні дні й години прийому.</p>
      </header>
      {isMobile ? <ScheduleList scheduleController={scheduleController}/> :
        <ScheduleTable scheduleController={scheduleController}/>}

      {
        isCreateModalOpen ? <ScheduleModal scheduleController={scheduleController}/> : null
      }
    </div>
    <ScrollToTopButton elementSelector={".page_content"}/>
  </div>

}

export default AdmissionSchedulePage
